<template>
  <v-carousel
    v-model="currentDot"
    :show-arrows="false"
    :show-arrows-on-hover="false"
    hide-delimiter-background
    hide-delimiters
    delimiter-icon="mdi-circle"
    :continuous="false"
    class="voucherGroup"
  >
    <v-carousel-item v-for="(item, index) in items" :key="index">
        <VoucherCard :voucher="item" :formatter="formatter" />
    </v-carousel-item>
  </v-carousel>

  <PaginationDots
    class="mb-2"
    :total-items="items.length"
    :current-index="currentDot"
    :maxDots="visibleDots"
  />
</template>

<script>
import VoucherCard from './elements/VoucherCard.vue';
import PaginationDots from './elements/PaginationDots.vue';

export default {
  name: 'VoucherCarousel',
  components: { VoucherCard, PaginationDots },
  emits: ['voucherSelected'],
  props: {
    items: {
      type: Array,
      required: true
    },
    formatter: {
      type: Object,
      required: true
    },
    visibleDots: {
      type: Number,
      default: 5
    },
    defaultVoucherId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      currentDot: 0
    };
  },
  computed: {
  },
  watch: {
    items: {
      handler(newItems) {
        if (this.defaultVoucherId) {
          const idx = newItems.findIndex(v => v.id == this.defaultVoucherId);
          if (idx !== -1) {
            this.currentDot = idx;
          }
        }
      },
      immediate: true
    },
    currentDot(newIndex) {
      this.emitCurrentIndex(newIndex);
    },
  },
  methods: {
    emitCurrentIndex(index) {
      this.$emit('voucherSelected', index);
    },
  },
};
</script>

<style scoped>
.voucherGroup {
	height: 210px !important;
	margin-left: -20px !important;
	margin-right: -20px !important;
	width: 100vw !important;
}
</style>
